import styles from "./button.module.scss";
export interface IButtonProps extends React.HTMLProps<HTMLButtonElement> {
	outlined?: boolean;
	loading?: boolean;
	children: React.ReactNode;
	onClick: () => void;
}

const Button = ({ outlined, loading, children, ...rest }: IButtonProps): JSX.Element => {
	const Loader = () => (
		<span className={styles.loaderContainer}>
			<small>carregando...</small>
			<div className={styles.loader} />
		</span>
	);

	return (
		<button {...rest} className={`${styles.button}  ${outlined && styles.outlined}`} type="button">
			{loading ? <Loader /> : children}
		</button>
	);
};

export default Button;
